import { Converters } from '~/utils/converters';

export interface ExportColumn {
	[name: string]: string;
}

export class Export {
	public static exportToCSV(
		filename: string,
		data: Array<{ [prop: string]: any }>,
	) {
		const csvContents = this.convertArrayOfObjectsToCsvString(data);
		if (csvContents !== null) {
			const blob = new Blob([csvContents], {
				type: 'data:text/csv;charset=utf-8',
			} as BlobPropertyBag);
			const url = URL.createObjectURL(blob);
			const downloadFilename = filename || 'export.csv';

			const link = document.createElement('a');
			link.setAttribute('href', url);
			link.setAttribute('download', downloadFilename);
			link.click();
		}
	}

	private static convertArrayOfObjectsToCsvString(
		data: Array<{ [prop: string]: any }>,
	) {
		if (data == null || !data.length) {
			return null;
		}

		const columnDelimiter = ',';
		const lineDelimiter = '\n';

		const keys = Object.keys(data[0]);

		let result = '';
		result += keys.join(columnDelimiter);
		result += lineDelimiter;

		data.forEach((item) => {
			let ctr = 0;
			keys.forEach((key) => {
				const value = item[key];
				if (ctr > 0) {
					result += columnDelimiter;
				}
				if (value?.dataType?.name === 'Date') {
					result += Converters.dateFormat(value.value);
				} else if (!value) {
					if (value === 0) {
						result += '0';
					} else {
						result += '';
					}
				} else {
					result += value;
				}
				ctr++;
			});
			result += lineDelimiter;
		});

		// if first two characters of file are ID, opening file results in SYLK: File format is not valid error
		if (result.substr(0, 2) === 'ID') {
			result = result.replace(result.substr(0, 2), 'Id');
		}

		return result;
	}
}
